module.exports = __webpack_public_path__ + "static/banner-image-0a15e096e86ac06068e4ca9791f7e23c.png";